import * as yup from "yup";

export const signinStep1Schema = yup.object().shape({
  email: yup.string().email("E-mail must be valid").required("The field is required."),
});
